/* global slideshow_options: false */
// https://www.npmjs.com/package/vue-carousel

// import Vue from 'vue';
// import { Carousel, Slide } from 'vue-carousel';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';

const $postSlider = $('.post-carousel');

if ($postSlider) {
	var slides_count = $postSlider.find('.post-group').length;
	if (slides_count > 1) {
		const slkOpts = {
			arrows: false,
			dots: true,
			speed: 500,
			autoplaySpeed: 5500,
			autoplay: false,
			pauseOnHover: false,
		};

		$postSlider.slick(slkOpts);
	} else {
		setTimeout(function () {
			$postSlider.find('.slide').addClass('active-slide');
		}, 500);
	}
}